export enum CallTrackerResponse {
  EventPublished = 'EventPublished',
  EventNotPublished = 'EventNotPublished',
}
